import {combineReducers} from 'redux'
import {all, fork} from 'redux-saga/effects'
import {connectRouter, RouterState} from 'connected-react-router'
import {History} from 'history'
import {loginStateInterface} from "./login/types";
import {loginReducer} from "./login/reducers";
import loginSaga from "./login/sagas";
import { chargePackageReducer } from "./chargePackage/reducers"
import { ChargePackageStateInterface } from "./chargePackage/types"
import chargePackageSaga from "./chargePackage/sagas"
import { internetPackageReducer } from "./internetPackage/reducers"
import { InternetPackageStateInterface } from "./internetPackage/types"
import internetPackageSaga from "./internetPackage/sagas"
import { giftCardStateInterface } from "./giftCard/types"
import { giftCardReducer } from "./giftCard/reducers"
import giftCardSaga from "./giftCard/sagas"


export interface ApplicationState {
    router: RouterState
    authorization: loginStateInterface
    payment: ChargePackageStateInterface
    internet: InternetPackageStateInterface
    giftCard: giftCardStateInterface
}

export const createRootReducer = (history: History) =>
    combineReducers({
        router: connectRouter(history),
        authorization: loginReducer,
        payment: chargePackageReducer,
        internet: internetPackageReducer,
        giftCard: giftCardReducer
    })

export function* rootSaga() {
    yield all([
        fork(loginSaga),
        fork(chargePackageSaga),
        fork(internetPackageSaga),
        fork(giftCardSaga)
    ])
}